import { createRouter, createWebHistory } from 'vue-router';
import { store } from '@/store/store';
import MyProfile from '@/components/MyProfile.vue';
import HomePage from '@/views/HomePage.vue';
import ProductDetails from '@/views/ProductDetails.vue';
import LoginPage from '@/views/LoginPage.vue';
import SignupPage from '@/views/SignupPage.vue';
import WishlistPage from '@/views/WishlistPage.vue';
import CartPage from '@/views/CartPage.vue';
import CheckoutPage from '@/views/CheckoutPage.vue';
import OrdersPage from '@/views/OrdersPage.vue';
import SearchPage from '@/views/SearchPage.vue';
import ComparePage from '@/views/ComparePage.vue';
import ContactPage from '@/views/ContactPage.vue';
import AboutUs from '@/views/AboutUs.vue';
import CategoryPage from '@/views/CategoryPage.vue';
import BrandPage from '@/views/BrandPage.vue';

const routes = [
  { path: '/', component: HomePage },
  { path: '/product/:id/:slug?', name: 'ProductDetails', component: ProductDetails },
  { path: '/login', component: LoginPage },
  { path: '/signup', component: SignupPage },
  { path: '/profile', component: MyProfile, meta: { requiresAuth: true }  },
  { path: '/wishlist', component: WishlistPage  },
  { path: '/cart', component: CartPage  },
  { path: '/checkout', component: CheckoutPage  },
  { path: '/orders', component: OrdersPage  },
  { path: '/search', component: SearchPage  },
  { path: '/compare', component: ComparePage  },
  { path: '/category', component: CategoryPage  },
  { path: '/brand/:slug', name: 'BrandPage', component: BrandPage  },
  { path: '/about', component: AboutUs  },
  { path: '/contact', component: ContactPage  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
  linkActiveClass: 'active', // <-- Bootstrap .active class
  linkExactActiveClass: 'active' // optional, for exact match
});

// Navigation Guard for Auth
router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters.isLoggedIn
  if (to.meta.requiresAuth && !isLoggedIn) {
    next('/login');
  } else {
    next();
  }
});

export default router;
